import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { Button } from '@/shared/components/button';
import { Modal } from '@/shared/components/modal';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { buildQaTrackingEntityProps } from '@/shared/modules/qa-tracking-entity';
import * as Styled from './confirmation-sing-out-modal.styled';
interface ConfirmationSignOutModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}
export const ConfirmationSignOutModal = React.memo(function ConfirmationSignOutModal({
  isOpen,
  onConfirm,
  onCancel
}: ConfirmationSignOutModalProps) {
  const profileModel = useEdgeConfigWidget(WidgetId.Profile);
  return <Modal isOpen={isOpen} shouldCloseOnOverlayClick={false} onClose={onCancel}>
      <Styled.Wrapper>
        <Styled.Text>{profileModel.strings.confirmationModalText}</Styled.Text>
        <Styled.ButtonsHolder>
          <Button size="m" color="systemRegular" onClick={onCancel} {...buildQaTrackingEntityProps('logout.button.cancel')}>
            {profileModel.strings.no}
          </Button>
          <Button size="m" color="secondary" onClick={onConfirm} {...buildQaTrackingEntityProps('logout.button.logout')}>
            {profileModel.strings.leave}
          </Button>
        </Styled.ButtonsHolder>
      </Styled.Wrapper>
    </Modal>;
});